import {
	alternateTitleColor,
	brandPrimary,
	brandSecondary,
	label,
	mention,
	mentionDark,
	nameCircles,
} from '../../web/styles/colors';
import { BreakPoints, CssSelectors } from '../../web/styles/styles';
import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	calendarContainer: {
		padding: '0 25px',
		position: 'relative',
		[BreakPoints.forMaxWidth(790)]: {
			padding: 0,
		},
	},
	chooseADate: {
		paddingBottom: 20,
		textAlign: 'center',
	},
	dayPicker: {
		flexShrink: 0,
		margin: 'auto',
		maxWidth: 340,
		...CssSelectors.allDescendants(
			{
				// Neutral so weekday labels don't clash with customer brand colors.
				color: label,
				fontWeight: 600,
				padding: '0 10px',
			},
			'.DayPicker .DayPicker-Weekday'
		),
		...CssSelectors.allDescendants({ color: label }, '.DayPicker-NavBar-month'),
		// The shared DayPickerNavbarIcon hardcodes its fill, so the month arrows are recolored here
		// rather than in the icon, which other apps still want in Levitate cyan.
		...CssSelectors.allDescendants(
			{ fill: `var(--scheduler-interactive-fill, ${alternateTitleColor})` },
			'.DayPicker-NavBar-prev-button polygon'
		),
		...CssSelectors.allDescendants(
			{ fill: `var(--scheduler-interactive-fill, ${alternateTitleColor})` },
			'.DayPicker-NavBar-next-button polygon'
		),
		// The shared day-picker stylesheet hovers days to a fixed gray at a specificity the day
		// classes below can't reach, so the hover follows the brand from here instead.
		...CssSelectors.allDescendants(
			{ background: `var(--scheduler-interactive-tint-hover, ${nameCircles})` },
			'.day-picker-day:not(.day-picker-day--selected):hover'
		),
		[BreakPoints.forMaxWidth(350)]: {
			...CssSelectors.allDescendants(
				{
					padding: '0 5px',
				},
				'.DayPicker .DayPicker-Weekday'
			),
			...CssSelectors.allDescendants(
				{
					padding: 5,
				},
				'.DayPicker .DayPicker-Day'
			),
		},
	},
	dayPickerDateNotSelected: {
		background: `var(--scheduler-interactive-tint, ${mention})`,
		borderRadius: '50%',
	},
	dayPickerDateSelected: {
		background: `var(--scheduler-interactive-fill, ${brandPrimary})`,
		borderRadius: '50%',
		color: `var(--scheduler-interactive-text, #fff)`,
	},
	dayPickerDateToday: {
		':hover': {
			cursor: 'not-allowed',
			...CssSelectors.allChildren({
				display: 'block',
			}),
		},
		border: `1px solid var(--scheduler-accent-fill, ${brandSecondary})`,
		borderRadius: '50%',
		overflow: 'visible',
		pointerEvents: 'auto',
		position: 'relative',
	},
	tooltip: {
		background: `var(--scheduler-accent-tint, ${mention})`,
		border: `1px solid var(--scheduler-accent-border, ${mentionDark})`,
		borderRadius: 4,
		bottom: 'calc(100% + 5px)',
		color: '#000',
		display: 'none',
		padding: 10,
		position: 'absolute',
	},
});
